export class Fields {
    static cmpId = 'cmpId';
    static cmpVersion = 'cmpVersion';
    static consentLanguage = 'consentLanguage';
    static consentScreen = 'consentScreen';
    static created = 'created';
    static supportOOB = 'supportOOB';
    static isServiceSpecific = 'isServiceSpecific';
    static lastUpdated = 'lastUpdated';
    static numCustomPurposes = 'numCustomPurposes';
    static policyVersion = 'policyVersion';
    static publisherCountryCode = 'publisherCountryCode';
    static publisherCustomConsents = 'publisherCustomConsents';
    static publisherCustomLegitimateInterests = 'publisherCustomLegitimateInterests';
    static publisherLegitimateInterests = 'publisherLegitimateInterests';
    static publisherConsents = 'publisherConsents';
    static publisherRestrictions = 'publisherRestrictions';
    static purposeConsents = 'purposeConsents';
    static purposeLegitimateInterests = 'purposeLegitimateInterests';
    static purposeOneTreatment = 'purposeOneTreatment';
    static specialFeatureOptins = 'specialFeatureOptins';
    static useNonStandardTexts = 'useNonStandardTexts';
    static vendorConsents = 'vendorConsents';
    static vendorLegitimateInterests = 'vendorLegitimateInterests';
    static vendorListVersion = 'vendorListVersion';
    static vendorsAllowed = 'vendorsAllowed';
    static vendorsDisclosed = 'vendorsDisclosed';
    static version = 'version';
}
